import React from "react";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import Card, { CardContent } from "material-ui/Card";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import classnames from "classnames";
import SmartFlagsModal from "../../../job/smart-flags-modal";

import GetThumbnailResultView from "./getThumbnailResult";

const SMART_FLAG_SUBTEST_MAPPINGS = {
  Length: {
    categoryFlags: ["Length"],
    names: ["Length"]
  },
  NEXT: {
    categoryFlags: ["NextMargin"],
    names: ["NEXT Margin"]
  },
  RTNLOSS: {
    categoryFlags: ["ReturnLossMargin"],
    names: ["Return Loss Margin"]
  },
  ATTEN: {
    categoryFlags: ["InsertionLossMargin"],
    names: ["Insertion Loss Margin"]
  },
  ACRF: {
    categoryFlags: ["ACRFMargin"],
    names: ["ACR-F Margin"]
  }
};

class ThumbnailViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      smartFlagsModalOpen: false
    };
  }

  setSubtestView = e => {
    const { subtest, onChangeResultsViewer } = this.props;
    onChangeResultsViewer(subtest);
  };

  openSmartFlagsModal = event => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({ smartFlagsModalOpen: true });
  };

  closeSmartFlagsModal = () => {
    this.setState({ smartFlagsModalOpen: false });
  };

  render() {
    const {
      classes,
      results,
      subtest,
      smartFlagChecks,
      translate,
      pager,
      getSubtestResults,
      subtestResultsRemote,
      subtestResultsDisplay,
      subtestResultsWiremap,
      chartLineStyle,
      chartMeasurement,
      chartMeasurementUnit,
      wiremapStandard,
      showMargin,
      setPreferences,
      preferences,
      test,
      graphable,
      onChangeResultsViewer
    } = this.props;
    const { smartFlagsModalOpen } = this.state;

    let View = GetThumbnailResultView(subtest);
    const currentTestId = pager && pager.tid;

    let status = "";
    let subtestRes;
    if (subtest === "Wiremap") {
      status = subtestResultsWiremap ? subtestResultsWiremap.Status : "";
    } else {
      if (subtest === "HeadRoom") {
        subtestRes = results.data.othersubtests.find(
          x => x.subtesttype === subtest
        );
      } else {
        subtestRes = results.data.lfttest.find(
          x => x.subtesttypeid === subtest
        );
      }
      if (subtestRes === undefined) {
        subtestRes = results.data.subtests.find(x => x.subtesttype === subtest);
      }
      if (subtestRes) {
        status = subtestRes.subteststatus;
      }
    }
    const tileBorderClass = status => {
      switch (status) {
        case "Pass":
          return classes.borderpassed;
        case "Fail":
          return classes.borderfailed;
        case "MarginalFail":
          return classes.borderfailed;
        case "MarginalPass":
          return classes.borderpassed;
        default:
          return classes.bordernotrun;
      }
    };

    const smartFlagMapping = SMART_FLAG_SUBTEST_MAPPINGS[subtest];
    const hasDirectSmartFlagFailure =
      !!smartFlagMapping &&
      currentTestId !== undefined &&
      currentTestId !== null &&
      Array.isArray(smartFlagChecks) &&
      smartFlagChecks.some(check => {
        const testId = check.testId || check.TestId;
        const categoryFlag = check.categoryFlag || check.CategoryFlag;
        const name = check.name || check.Name;

        return (
          String(testId) === String(currentTestId) &&
          (smartFlagMapping.categoryFlags.includes(categoryFlag) ||
            smartFlagMapping.names.includes(name))
        );
      });

    return (
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
        <Card
          className={classnames(classes.cardCover, tileBorderClass(status))}
        >
          {hasDirectSmartFlagFailure && (
            <Icon
              className={classes.failFlag}
              onClick={this.openSmartFlagsModal}
            >
              flag
            </Icon>
          )}
          <CardContent className={classes.cardContent}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.content}
              >
                <View
                  thumbnailView
                  results={results}
                  subtest={subtest}
                  translate={translate}
                  pager={pager}
                  getSubtestResults={getSubtestResults}
                  subtestResultsRemote={subtestResultsRemote}
                  subtestResultsDisplay={subtestResultsDisplay}
                  subtestResultsWiremap={subtestResultsWiremap}
                  chartLineStyle={chartLineStyle}
                  chartMeasurement={chartMeasurement}
                  chartMeasurementUnit={chartMeasurementUnit}
                  wiremapStandard={wiremapStandard}
                  showMargin={showMargin}
                  setPreferences={setPreferences}
                  preferences={preferences}
                  subtestRes={subtestRes}
                />
              </Grid>
              <Grid container spacing={0} className={classes.thumbnailNav}>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                ></Grid>
                <Grid
                  item
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                >
                  <Typography
                    variant="headline"
                    component="h2"
                    className={classes.subtesttitle}
                  >
                    {translate(subtest)}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                >
                  {graphable && <Icon>insert_chart_outlined</Icon>}
                </Grid>
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  lg={2}
                  xl={2}
                  className={classnames(
                    classes.cardActionsNav,
                    status === "Pass"
                      ? classes.cardActionsNavPassed
                      : status === "Fail"
                      ? classes.cardActionsNavFailed
                      : classes.cardActionsNavNotRun
                  )}
                >
                  {status !== "" && subtest !== "HeadRoom" && (
                    <Button
                      mini
                      className={classes.nav}
                      onClick={this.setSubtestView}
                    >
                      <Icon>keyboard_arrow_right</Icon>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <SmartFlagsModal
          testId={currentTestId}
          isOpen={smartFlagsModalOpen}
          onClose={this.closeSmartFlagsModal}
        />
      </Grid>
      // </Grid>
    );
  }
}

const mapStateToProps = state => ({
  smartFlagChecks: state.smartFlagReducer.smartFlagChecks
});

export default connect(mapStateToProps)(withStyles(styles)(ThumbnailViewer));
